import './ForgotPassword.scss';
import { Icon } from '../../icon/icon';
import ButtonIconGhostMedium from '../../common/ButtonIconGhost/ButtonIconGhostMedium';
import ButtonPrimaryLarge from '../../common/ButtonPrimary/ButtonPrimaryLarge';
import ButtonLink from '../../common/ButtonLink/ButtonLink';
import { Form } from 'antd';
import InputComponent from '../../common/InputComponent/InputComponent';
import { Modal } from 'antd';
import useModalAlertCheckMail from '../AlertCheckMail/AlertCheckMail';
import { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { forgotPassword } from '../../../store/actions/auth.action';
import { useTranslation } from 'react-i18next';
import { openModal } from '../../common/Modal/openModal';
import { openMessageError } from '../../common/Message/openMessageError';

const useModalForgotPassword = () => {
  const modal = useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // const navigate = useNavigate();

  const submit = (values, onOpenAlertCheckMail) => {
    dispatch(
      forgotPassword({
        email: values.email,
        redirect_url: window.location.origin,
      })
    )
      .then(action => {
        if (action.payload?.data) {
          onOpenAlertCheckMail(values.email);
          modal.current?.destroy();
          // document.location.href = action.payload?.data;
        } else if (
          action.error ||
          action.meta?.requestStatus === 'rejected'
        ) {
          openMessageError({
            content: action.error?.message || t('Something went wrong'),
          });
        }
      })
      .catch(error => {
        openMessageError({
          content: error?.message || t('Something went wrong'),
        });
      });
  };
  const openModalForgotPassword = ({ onOpenLogin, onOpenAlertCheckMail }) => {
    modal.current = openModal({
      content: (
        <>
          <Form
            layout="vertical"
            onFinish={values => submit(values, onOpenAlertCheckMail)}
          >
            <div className="flex py-16 px-40 justify-center items-center gap-8 self-stretch">
              <h2>{t('Forgot password')}</h2>
            </div>
            <div className="flex py-16 px-40 justify-center items-center gap-16 flex-col self-stretch">
              <Form.Item
                label={'Email'}
                name={'email'}
                className="self-stretch"
              >
                <InputComponent placeholder={t('Enter email')} size="large" />
              </Form.Item>
            </div>
            <Form.Item className="flex py-16 px-40 justify-center items-center gap-8 self-stretch">
              <ButtonPrimaryLarge
                type={'submit'}
                title={t('Receive reset link')}
                className={'grow'}
              />
            </Form.Item>
            <div className="flex p-40 pt-16 justify-center items-center gap-8 self-stretch">
              <div className="flex justify-center items-center gap-8">
                <span className="text-body-medium">
                  {t("You don't have a Fitta account?")}
                </span>
                <ButtonLink
                  title={t('Login')}
                  style={{ color: '#258FD2' }}
                  onClick={() => {
                    modal.current?.destroy();
                    onOpenLogin();
                  }}
                />
              </div>
            </div>
          </Form>
        </>
      ),
      title: (
        <div className="flex p-40 pb-16 justify-center items-center self-stretch m-0">
          <a
            href={'/'}
            style={{
              backgroundImage: 'url(/assets/logo/new_logo_fitta.png)',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              height: '32px',
              width: '120px',
              display: 'inline-block',
            }}
          ></a>
          <ButtonIconGhostMedium
            icon={<Icon.ICClose />}
            style={{ border: '1px solid #CFD1D2' }}
            className={'absolute top-24 right-24'}
            onClick={() => modal.current?.destroy()}
          />
        </div>
      ),
      footer: null,
      centered: true,
      closable: false,
      classNames: { content: '!p-0 !rounded-[8px]', header: '!m-0' },
      width: 620,
      styles: {
        mask: {
          background: 'rgba(221, 221, 221, 0.38)',
          backdropFilter: 'blur(8px)',
        },
      },
    });
  };
  return { openModalForgotPassword };
};

export default useModalForgotPassword;
